import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
   {
      path: '/',
      name: 'home',
      // component: HomeView
      component: () => import('@/views/home/index.vue')
   },
   {
      path: '/recruit',
      name: 'recruit',
      component: () => import('@/views/recruit/index.vue')
   },
   {
      path: '/recruit/:id',
      name: 'recruitDetail',
      component: () => import('@/views/recruit/jobDetail.vue')
   },
   {
      path: '/honor',
      name: 'honor',
      component: () => import('@/views/honor/index.vue')
   },
   {
      path: '/solution',
      name: 'solution',
      component: () => import('@/views/solution/index.vue')
   },

   {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/views/aboutUs/index.vue')
   },
   {
      path: '/customerCase',
      name: 'customerCase',
      component: () => import('@/views/customerCase/index.vue')
   },
   {
      path: '/customerCaseDetails',
      name: 'customerCaseDetails',
      component: () => import('@/views/customerCase/customerCaseDetails.vue')
   },



]

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes
})

export default router
